import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-clinic",
          title:
            _setup.lpuFiltersState.lpuType?.name ||
            _setup.t("Тип клиники", _setup.options),
          subtitle: _setup.lpuFiltersState.lpuType
            ? _setup.t("Тип клиники", _setup.options)
            : "",
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.LpuTypeModal, {
        attrs: { value: _setup.isDialogOpened, "is-back": "" },
        on: {
          "lpu-type:selected": _setup.onClickLpuType,
          input: _setup.handleCloseLpuTypeModal,
        },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedLpuType }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedLpuType,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleLpuTypeSelected(selectedLpuType)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }